import Vue from 'vue';

const DefaultView = Vue.component('DefaultView', { render: (h) => h('router-view') });

export default DefaultView;
